import { actionTypes } from '../../types';

// Action request
export const createAgencyUser = (payload, callback) => ({
    type: actionTypes.CREATE_AGENCY_USER_REQUEST,
    payload,
    callback
});

// Action success
export const createAgencyUserSuccess = (payload) => ({
    type: actionTypes.CREATE_AGENCY_USER_SUCCESS,
    payload,
});

// Action failure
export const createAgencyUserFailure = (payload) => ({
    type: actionTypes.CREATE_AGENCY_USER_FAILURE,
    payload,
});

// Action reset status
export const createAgencyUserReset = () => ({
    type: actionTypes.CREATE_AGENCY_USER_RESET,
});

// Action reset all reducer
export const createAgencyUserResetAll = () => ({
    type: actionTypes.CREATE_AGENCY_USER_RESET_ALL,
});
